import './index.css';
import Modal from "./Modal";
function App() {
  return (
    <div>
      <Modal />
    </div>
  );
}

export default App;
